import { Avatar, CardActions } from "@mui/material";
import Link from "next/link";
import React from "react";
import * as constants from "../../../Components/constants";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { Row, Col } from "react-bootstrap";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import bannerImg from "../../../Components/PRTPLanding/PRTPBanner/banner.json";
import style from "./GroupPreview.module.css";
import Lottie from "lottie-react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import VerifiedIcon from "@mui/icons-material/Verified";

const BASE_URL = constants.BASE_URL;

const GroupPreview = ({ adsId }) => {
  const [groups, setGroups] = React.useState([]);

  console.log(groups);

  React.useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await fetch(`${BASE_URL}/group/all-groups/`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        const shuffled = data
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);
        setGroups(shuffled.slice(0, 31));
      } catch (error) {
        console.log(error);
      }
    };
    fetchGroups();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between pb-3">
        <span className="fs-6 fw-bold">Suggested Group</span>
        <ImportExportIcon />
      </div>
      <Row
        xs={1}
        sm={2}
        md={2}
        xl={2}
        xxl={3}
        className={`${style.overflow} g-2 justify-content-center`}
      >
        <Card sx={{ height: 270, cursor: "pointer" }} className="rounded-3">
          <Lottie
            className={`${style.animImg}`}
            animationData={bannerImg}
            loop={true}
          />

          <CardContent>
            <Link href="/prtp">
              <a target="_blank">
                <Typography className="text-dark" component="div" fontSize={14}>
                  <b>Professional Research Training Program (PRTP)</b>
                </Typography>
              </a>
            </Link>
          </CardContent>

          <CardActions>
            <Typography
              gutterBottom
              variant="caption"
              component="div"
              display="flex"
              alignItems="center"
            >
              <span className={`${style.bg_ads} me-1`}>Ad.</span>{" "}
              <Link href="/prtp">
                <a target="_blank">www.researchrider.com/prtp</a>
              </Link>
            </Typography>
          </CardActions>
        </Card>

        {groups.map((group, idx) => {
          return (
            <React.Fragment key={idx}>
              <Col>
                <Link href={`/group/${group.id}`}>
                  <a target="_blank">
                    <Card
                      sx={{ height: 270, cursor: "pointer" }}
                      className="rounded-3"
                    >
                      <Avatar
                        className="border rounded-3"
                        sx={{
                          objectFit: "cover",
                          width: "100%",
                          height: "140px",
                        }}
                        src={group.cover_pic}
                        alt={group.name}
                      />
                      <CardContent>
                        <Typography
                          component="div"
                          display="flex"
                          alignItems="center"
                          fontSize={14}
                        >
                          <Avatar
                            className="border rounded-pill"
                            sx={{
                              objectFit: "cover",
                              width: "35px",
                              height: "35px",
                            }}
                            src={group.profile_pic}
                            alt={group.name}
                          />
                          <b className="px-1 ">
                            {group.name.slice(0, 20)}{" "}
                            {group.is_verified && (
                              <VerifiedIcon
                                color="primary"
                                sx={{ fontSize: "20px" }}
                              />
                            )}
                          </b>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <span className="text-break">
                            {group.about.slice(0, 50)}..
                          </span>
                        </Typography>
                      </CardContent>
                    </Card>
                  </a>
                </Link>
              </Col>
            </React.Fragment>
          );
        })}
      </Row>
      <div className="text-center">
        <Link href={`/group/discover`}>
          <Typography
            className={`${style.see}`}
            align="center"
            variant="caption"
            fontWeight={600}
            fontSize={14}
          >
            See all groups <KeyboardArrowRightIcon />
          </Typography>
        </Link>
      </div>
    </>
  );
};

export default GroupPreview;
